import { useState } from "react";
import { cambiarClave } from "../api/apiConfig";

const CambioClave = ({ onBackToLogin }) => {
  const [formData, setFormData] = useState({
    email: "",
    claveAnterior: "",
    nuevaClave: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const result = await cambiarClave({
        email: formData.email,
        claveAnterior: formData.claveAnterior,
        nuevaClave: formData.nuevaClave,
      });

      if (result.success) {
        setMessage("Contraseña cambiada exitosamente");
        setTimeout(() => onBackToLogin(), 2000);
      } else {
        setMessage(result.message || "Error al cambiar contraseña");
      }
    } catch (error) {
      console.error("Error al cambiar contraseña:", error);
      setMessage("Error de conexión con el servidor");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-container">
      <div className="left-side-register">
        <div className="logo-container">
        </div>
        <div className="bottom-text">
          <h1>Cambia tu<br />contraseña</h1>
          <p>Actualiza tu clave de acceso</p>
        </div>
      </div>

      <div className="right-side">
        <div className="login-form-container">
          <div className="login-header">
            <div className="mgc-title">
              <img src="/img/logo.png" alt="Logo" className="logo-img" />
              <span className="mgc-text"><strong>MGC</strong> Cambio de clave</span>
            </div>
            <p className="login-subtitle">Ingresa tu email y contraseñas</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="email"
                name="email"
                placeholder="Correo electrónico"
                className="login-input"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="password"
                name="claveAnterior"
                placeholder="Contraseña anterior"
                className="login-input"
                value={formData.claveAnterior}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="password"
                name="nuevaClave"
                placeholder="Nueva contraseña"
                className="login-input"
                value={formData.nuevaClave}
                onChange={handleChange}
                required
              />
            </div>

            {message && (
              <div className={`message ${message.includes('exitosamente') ? 'success' : 'error'}`}>
                {message}
              </div>
            )}

            <button
              type="submit"
              className="login-button"
              disabled={loading}
            >
              {loading ? 'Cambiando contraseña...' : 'Cambiar contraseña'}
            </button>
          </form>

          <div className="footer-text">
            <button 
              onClick={onBackToLogin}
              className="link-button"
            >
              Volver al inicio de sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CambioClave;
